import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewCalendarModule"
const debug = false

export class ViewCalendarModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_CALENDAR, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Calendar"
        this.description                = "The Calendar view serves as an efficient tool for displaying and managing tasks, events, and deadlines within your workspace. It offers users a comprehensive view of upcoming activities, facilitating effective planning and coordination of schedules."
        this.svgIcon                    = "isvg-view-calendar"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-calendar"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS


    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}